// The kit's lexicon, ported from tools/generate_paradigms.py (same order, same meanings).
// Everything here is `needs_review` until a Prakrit teacher approves it in the admin.

import type { Gender } from '@/prakrit/lib/grammar/types'

export const SOURCE = 'प्राकृत स्वयं-शिक्षक खण्ड १ (प्रेम सुमन जैन, 1998)'

export const SOURCE_FULL = {
    title: 'प्राकृत स्वयं-शिक्षक, खण्ड १',
    author: 'प्रेम सुमन जैन',
    publisher: 'प्राकृत भारती अकादमी, जयपुर',
    edition: 'तृतीय संस्करण',
    year: 1998
}

export type LexVerb = [root: string, hi: string, en: string]
export type LexNoun = [stem: string, gender: Gender, hi: string, en: string]

// अकारान्त धातु
export const VERBS_A: LexVerb[] = [
    ['पढ', 'पढ़ना', 'to read'], ['पास', 'देखना', 'to see'], ['गच्छ', 'जाना', 'to go'],
    ['इच्छ', 'इच्छा करना', 'to wish'], ['खेल', 'खेलना', 'to play'], ['सुण', 'सुनना', 'to hear'],
    ['भुंज', 'भोजन करना', 'to eat'], ['पुच्छ', 'पूछना', 'to ask'], ['कह', 'कहना', 'to tell'],
    ['खण', 'खोदना', 'to dig'], ['कर', 'करना', 'to do'], ['गिण्ह', 'ग्रहण करना', 'to take'],
    ['नम', 'नमन करना', 'to bow'], ['जाण', 'जानना', 'to know'], ['धाव', 'दौड़ना', 'to run'],
    ['हस', 'हँसना', 'to laugh'], ['णच्च', 'नाचना', 'to dance'], ['सेव', 'सेवा करना', 'to serve'],
    ['सय', 'सोना', 'to sleep'], ['अच्च', 'पूजा करना', 'to worship'], ['चित', 'चिंतन करना', 'to think'],
    ['चल', 'चलना', 'to walk'], ['भम', 'घूमना', 'to wander'], ['जय', 'जीतना', 'to win'],
    ['लिह', 'लिखना', 'to write'], ['वस', 'रहना', 'to live'], ['बंध', 'बाँधना', 'to tie'],
    ['पिव', 'पीना', 'to drink'], ['भण', 'कहना', 'to say'], ['आगच्छ', 'आना', 'to come'],
    ['पेस', 'भेजना', 'to send'], ['कीण', 'खरीदना', 'to buy'], ['जिण', 'जीतना', 'to conquer'],
    ['बीह', 'डरना', 'to fear'], ['कंद', 'रोना', 'to cry'], ['पाल', 'पालन करना', 'to protect'],
    ['सीख', 'सीखना', 'to learn'], ['जंप', 'बोलना', 'to speak'], ['दह', 'जलना', 'to burn'],
    ['णिम्म', 'बनाना', 'to make'], ['तुल', 'तौलना', 'to weigh'], ['घोस', 'घोषणा करना', 'to announce'],
    ['फास', 'छूना', 'to touch'], ['गज्ज', 'गर्जना', 'to roar'], ['थुण', 'स्तुति करना', 'to praise'],
    ['कलह', 'झगड़ना', 'to quarrel'], ['लज्ज', 'लजाना', 'to be shy'], ['उड्ड', 'उड़ना', 'to fly'],
    ['जग्ग', 'जागना', 'to wake'], ['तर', 'तैरना', 'to swim'], ['कस्स', 'जोतना', 'to plough'],
    ['खम', 'क्षमा करना', 'to forgive'], ['पच', 'पकाना', 'to cook'], ['दुह', 'दुहना', 'to milk'],
    ['तूस', 'संतुष्ट होना', 'to be pleased'], ['विरम', 'अलग होना', 'to stop'], ['सोह', 'शोभित होना', 'to shine'],
    ['पड', 'गिरना', 'to fall'], ['तव', 'तप करना', 'to do penance'], ['धोव', 'धोना', 'to wash'],
    ['पविस', 'प्रवेश करना', 'to enter'], ['पलाय', 'भाग जाना', 'to flee'], ['पीस', 'पीसना', 'to grind'],
    ['पेच्छ', 'देखना', 'to look'], ['हिंस', 'हिंसा करना', 'to harm'], ['रूस', 'क्रोधित होना', 'to be angry'],
    ['धर', 'पकड़ना', 'to hold'], ['मग्ग', 'माँगना', 'to ask for'], ['मुंच', 'छोड़ना', 'to release'],
    ['बोल्ल', 'बोलना', 'to speak'], ['मन्न', 'मानना', 'to believe'], ['हव', 'होना', 'to be'],
    ['ताड', 'पीटना', 'to beat'], ['हण', 'मारना', 'to kill'], ['वड्ढ', 'बढ़ना', 'to grow'],
    ['अच्छ', 'ठहरना', 'to stay'], ['रम', 'रमण करना', 'to enjoy'], ['निन्द', 'निन्दा करना', 'to blame'],
    ['लंभ', 'प्राप्त करना', 'to obtain'], ['सर', 'याद करना', 'to remember'], ['हरिस', 'खुश होना', 'to rejoice'],
    ['उज्जम', 'प्रयत्न करना', 'to strive'], ['उवदिस', 'उपदेश देना', 'to teach'], ['उट्ठ', 'उठना', 'to rise'],
    ['सिंच', 'सींचना', 'to water'], ['चक्ख', 'स्वाद लेना', 'to taste'], ['सिव्व', 'सीना', 'to sew'],
    ['जुज्झ', 'युद्ध करना', 'to fight'], ['णीसर', 'निकलना', 'to come out'], ['पसंस', 'प्रशंसा करना', 'to praise'],
    ['मुण', 'जानना', 'to know'], ['विक्कीण', 'बेचना', 'to sell'], ['चिण', 'चुनना', 'to pick']
]

// आ / ए / ओ-ending roots
export const VERBS_LONG: LexVerb[] = [
    ['दा', 'देना', 'to give'], ['गा', 'गाना', 'to sing'], ['खा', 'खाना', 'to eat'],
    ['झा', 'ध्यान करना', 'to meditate'], ['पा', 'पीना', 'to drink'], ['ठा', 'ठहरना', 'to stand'],
    ['ण्हा', 'नहाना', 'to bathe'], ['णे', 'ले जाना', 'to carry away'], ['आणे', 'ले आना', 'to bring'], ['हो', 'होना', 'to be']
]

export const NOUNS: LexNoun[] = [
    // पुल्लिंग अकारान्त
    ['बालअ', 'pu', 'बालक', 'boy'], ['पुरिस', 'pu', 'आदमी', 'man'], ['छत्त', 'pu', 'छात्र', 'student'],
    ['सीस', 'pu', 'शिष्य', 'disciple'], ['णर', 'pu', 'मनुष्य', 'human'], ['निव', 'pu', 'राजा', 'king'],
    ['बुह', 'pu', 'बुद्धिमान', 'wise man'], ['भड', 'pu', 'योद्धा', 'warrior'], ['देव', 'pu', 'देवता', 'god'],
    ['आयरिअ', 'pu', 'आचार्य', 'teacher'], ['मेह', 'pu', 'बादल', 'cloud'], ['मिअ', 'pu', 'मृग', 'deer'],
    ['सीह', 'pu', 'सिंह', 'lion'], ['मोर', 'pu', 'मोर', 'peacock'], ['चोर', 'pu', 'चोर', 'thief'],
    ['उवज्झाय', 'pu', 'उपाध्याय', 'preceptor'], ['पुत्त', 'pu', 'पुत्र', 'son'], ['जणअ', 'pu', 'पिता', 'father'],
    ['भायर', 'pu', 'भाई', 'brother'], ['कर', 'pu', 'हाथ', 'hand'], ['कण्ण', 'pu', 'कान', 'ear'],
    ['दंत', 'pu', 'दाँत', 'tooth'], ['दंड', 'pu', 'लाठी', 'stick'], ['वणिअ', 'pu', 'बनिया', 'merchant'],
    ['गोव', 'pu', 'ग्वाला', 'cowherd'], ['सेवअ', 'pu', 'नौकर', 'servant'], ['वेज्ज', 'pu', 'वैद्य', 'physician'],
    ['किसाण', 'pu', 'किसान', 'farmer'], ['वानर', 'pu', 'बन्दर', 'monkey'], ['हंस', 'pu', 'हंस', 'swan'],
    ['रुक्ख', 'pu', 'पेड़', 'tree'], ['गाम', 'pu', 'गाँव', 'village'], ['घड', 'pu', 'घड़ा', 'pot'],
    ['दीवअ', 'pu', 'दीपक', 'lamp'], ['वसह', 'pu', 'बैल', 'bull'], ['कवोअ', 'pu', 'कबूतर', 'pigeon'],
    ['पासाय', 'pu', 'महल', 'palace'], ['कंदुअ', 'pu', 'गेंद', 'ball'], ['काय', 'pu', 'शरीर', 'body'],
    ['आवण', 'pu', 'दुकान', 'shop'], ['देस', 'pu', 'देश', 'country'], ['भमर', 'pu', 'भौंरा', 'bee'],
    ['भगवंत', 'pu', 'भगवान', 'the Lord'], ['जण', 'pu', 'लोग, व्यक्ति', 'person'], ['जुवाण', 'pu', 'युवक', 'young man'], ['अप्पाण', 'pu', 'आत्मा', 'self'],
    // पुल्लिंग इकारान्त / उकारान्त
    ['सुधि', 'pu', 'विद्वान्', 'scholar'], ['कवि', 'pu', 'कवि', 'poet'], ['कुलवइ', 'pu', 'कुलपति', 'chancellor'],
    ['सेट्ठि', 'pu', 'सेठ', 'merchant'], ['हत्थि', 'pu', 'हाथी', 'elephant'], ['जोगि', 'pu', 'योगी', 'yogi'],
    ['मुणि', 'pu', 'मुनि', 'sage'], ['तवस्सि', 'pu', 'तपस्वी', 'ascetic'], ['भूवइ', 'pu', 'राजा', 'king'],
    ['पक्खि', 'pu', 'पक्षी', 'bird'], ['उदहि', 'pu', 'समुद्र', 'ocean'], ['मणि', 'pu', 'रत्न', 'jewel'],
    ['अग्गि', 'pu', 'अग्नि', 'fire'], ['सामि', 'pu', 'स्वामी', 'master'], ['मंति', 'pu', 'मंत्री', 'minister'],
    ['सिसु', 'pu', 'बच्चा', 'child'], ['साहु', 'pu', 'साधु', 'monk'], ['गुरु', 'pu', 'गुरु', 'teacher'],
    ['तरु', 'pu', 'वृक्ष', 'tree'], ['पसु', 'pu', 'पशु', 'animal'], ['पिउ', 'pu', 'पिता', 'father'],
    ['पहु', 'pu', 'स्वामी', 'lord'], ['रिउ', 'pu', 'शत्रु', 'enemy'], ['बंधु', 'pu', 'भाई', 'kinsman'],
    ['भाणु', 'pu', 'सूर्य', 'sun'], ['वाउ', 'pu', 'हवा', 'wind'], ['जन्तु', 'pu', 'प्राणी', 'creature'],
    // स्त्रीलिंग
    ['बाला', 'stri', 'बालिका', 'girl'], ['माआ', 'stri', 'माता', 'mother'], ['सुण्हा', 'stri', 'बहू', 'daughter-in-law'],
    ['माला', 'stri', 'माला', 'garland'], ['कन्ना', 'stri', 'कन्या', 'maiden'], ['धूआ', 'stri', 'पुत्री', 'daughter'],
    ['नावा', 'stri', 'नाव', 'boat'], ['निसा', 'stri', 'रात्रि', 'night'], ['दिसा', 'stri', 'दिशा', 'direction'],
    ['आणा', 'stri', 'आज्ञा', 'command'], ['जीहा', 'stri', 'जीभ', 'tongue'], ['कला', 'stri', 'कला', 'art'],
    ['ससा', 'stri', 'बहिन', 'sister'], ['सहा', 'stri', 'सभा', 'assembly'], ['भासा', 'stri', 'भाषा', 'language'],
    ['लज्जा', 'stri', 'लज्जा', 'modesty'], ['खमा', 'stri', 'क्षमा', 'forgiveness'], ['सद्धा', 'stri', 'श्रद्धा', 'faith'],
    ['जुवइ', 'stri', 'युवती', 'young woman'], ['बुद्धि', 'stri', 'बुद्धि', 'intellect'], ['भत्ति', 'stri', 'भक्ति', 'devotion'],
    ['रत्ति', 'stri', 'रात', 'night'], ['कित्ति', 'stri', 'कीर्ति', 'fame'], ['मुत्ति', 'stri', 'मुक्ति', 'liberation'],
    ['संति', 'stri', 'शान्ति', 'peace'], ['नई', 'stri', 'नदी', 'river'], ['साडी', 'stri', 'साड़ी', 'sari'],
    ['कुमारी', 'stri', 'कुँआरी', 'maiden'], ['बहिणी', 'stri', 'बहिन', 'sister'], ['इत्थी', 'stri', 'स्त्री', 'woman'],
    ['दासी', 'stri', 'नौकरानी', 'maid'], ['लच्छी', 'stri', 'लक्ष्मी', 'Lakshmi'], ['पुहवी', 'stri', 'पृथ्वी', 'earth'],
    ['जणणी', 'stri', 'माता', 'mother'], ['धेणु', 'stri', 'गाय', 'cow'], ['विज्जु', 'stri', 'बिजली', 'lightning'],
    ['बहू', 'stri', 'बहू', 'bride'], ['सासू', 'stri', 'सास', 'mother-in-law'],
    // नपुंसकलिंग
    ['णयर', 'napum', 'नगर', 'city'], ['फल', 'napum', 'फल', 'fruit'], ['पुप्फ', 'napum', 'फूल', 'flower'],
    ['कमल', 'napum', 'कमल', 'lotus'], ['घर', 'napum', 'घर', 'house'], ['खेत्त', 'napum', 'खेत', 'field'],
    ['सत्थ', 'napum', 'शास्त्र', 'scripture'], ['पोत्थअ', 'napum', 'पुस्तक', 'book'], ['जल', 'napum', 'पानी', 'water'],
    ['दुद्ध', 'napum', 'दूध', 'milk'], ['चित्त', 'napum', 'चित्र', 'picture'], ['पत्त', 'napum', 'पत्र', 'letter'],
    ['वत्थ', 'napum', 'वस्त्र', 'cloth'], ['धण', 'napum', 'धन', 'wealth'], ['सुह', 'napum', 'सुख', 'happiness'],
    ['दुक्ख', 'napum', 'दुःख', 'sorrow'], ['कम्म', 'napum', 'कर्म', 'action'], ['वण', 'napum', 'जंगल', 'forest'],
    ['मित्त', 'napum', 'मित्र', 'friend'], ['नयण', 'napum', 'आँख', 'eye'], ['हियय', 'napum', 'हृदय', 'heart'],
    ['णाण', 'napum', 'ज्ञान', 'knowledge'], ['जीवण', 'napum', 'जीवन', 'life'], ['भोअण', 'napum', 'भोजन', 'food'],
    ['उववण', 'napum', 'उपवन', 'garden'], ['वागरण', 'napum', 'व्याकरण', 'grammar'], ['कव्व', 'napum', 'काव्य', 'poem'],
    ['सच्च', 'napum', 'सत्य', 'truth'], ['वारि', 'napum', 'पानी', 'water'], ['दहि', 'napum', 'दही', 'curd'],
    ['अक्खि', 'napum', 'आँख', 'eye'], ['वत्थु', 'napum', 'वस्तु', 'thing'], ['महु', 'napum', 'शहद', 'honey'],
    ['अंसु', 'napum', 'आँसू', 'tear'], ['विज्जालय', 'napum', 'विद्यालय', 'school'],
    ['गीअ', 'napum', 'गीत', 'song'], ['पाइय', 'napum', 'प्राकृत भाषा', 'Prakrit'], ['उज्जेणी', 'stri', 'उज्जैन', 'Ujjain']
]

// राय (राजा) is declined like पुरिस with the विकल्प रूप of नि.६४; it is appended after NOUNS.
export const RAYA = { stem: 'राय', gender: 'pu' as Gender, hi: 'राजा', en: 'king', rules: 'नि.६३–६४' }

export type LexAvyaya = [word: string, hi: string, en: string]

export const AVYAYA: LexAvyaya[] = [
    ['अत्थ', 'यहाँ', 'here'], ['तत्थ', 'वहाँ', 'there'], ['कत्थ', 'कहाँ', 'where'], ['जत्थ', 'जहाँ', 'where (rel.)'],
    ['सइ', 'एक बार', 'once'], ['मुहु', 'बार-बार', 'again and again'], ['सया', 'सदा', 'always'],
    ['दाणिं', 'इस समय', 'now'], ['सणिअं', 'धीरे', 'slowly'], ['झत्ति', 'शीघ्र', 'quickly'],
    ['अग्गओ', 'आगे', 'ahead'], ['ण', 'नहीं', 'not'], ['मा', 'मत', 'do not'], ['पइदिणं', 'प्रतिदिन', 'daily'],
    ['अज्ज', 'आज', 'today'], ['कल्ल', 'कल', 'yesterday / tomorrow'], ['अवस्स', 'अवश्य', 'certainly'],
    ['सह', 'साथ', 'with'], ['विणा', 'बिना', 'without'], ['किं', 'क्या', 'what'], ['कया', 'कब', 'when'],
    ['जइ … ता', 'यदि … तो', 'if … then'], ['जया … तया', 'जब … तब', 'when … then'],
    ['पुणो / पुणरवि', 'फिर से', 'again'], ['पच्छा', 'बाद में', 'later'], ['पुव्वं', 'पहले', 'before'],
    ['तओ', 'उसके बाद', 'then'], ['एवं', 'इस प्रकार', 'thus'], ['अलं', 'बस', 'enough'], ['अहो', 'आश्चर्य!', 'oh!'],
    ['णूणं', 'निश्चय ही', 'surely'], ['अ / य', 'और', 'and'], ['वि / पि', 'भी', 'also'], ['इव / व्व', 'जैसे', 'like'],
    ['णमो', 'नमस्कार', 'salutation'], ['अण्णहा', 'अन्यथा', 'otherwise']
]

/** The single words an अव्यय entry stands for: "वि / पि" → ["वि", "पि"], "जइ … ता" → ["जइ", "ता"]. */
export const avyayaSurfaces = (entry: string): string[] => entry
    .split(/\s*(?:\/|…)\s*/)
    .map(part => part.trim())
    .filter(Boolean)

export type LexNumber = [word: string, value: number]

export const NUMBERS_LIST: LexNumber[] = [
    ['एग', 1], ['दोण्णि', 2], ['तिण्णि', 3], ['चउरो', 4], ['पंच', 5], ['छ', 6], ['सत्त', 7], ['अट्ठ', 8],
    ['णव', 9], ['दह', 10], ['एगारह', 11], ['बारह', 12], ['तेरह', 13], ['चउद्दह', 14], ['पण्णरह', 15],
    ['सोलह', 16], ['सत्तरह', 17], ['अट्ठारह', 18], ['एगूणवीसा', 19], ['वीसा', 20], ['एगवीसा', 21],
    ['दुवीसा', 22], ['तेवीसा', 23], ['चउवीसा', 24], ['पण्णवीसा', 25], ['छव्वीसा', 26], ['सत्तवीसा', 27],
    ['अट्ठावीसा', 28], ['एगूणतीसा', 29], ['तीसा', 30], ['एगतीसा', 31], ['चतालीसा', 40],
    ['एगूणसट्ठि', 59], ['सट्ठि', 60], ['एगसट्ठि', 61], ['दोसट्ठि', 62], ['तेसट्ठि', 63], ['चउसट्ठि', 64],
    ['पणसट्ठि', 65], ['छसट्ठि', 66], ['सत्तसट्ठि', 67], ['अट्ठसट्ठि', 68], ['एगूणसत्तरि', 69], ['सत्तरि', 70],
    ['एकहत्तरि', 71], ['एगूणसीइ', 79], ['असीइ', 80], ['एगासीइ', 81], ['एगूणनवइ', 89], ['णवइ', 90],
    ['एगणवइ', 91], ['नवणवइ', 99], ['सय', 100], ['दुसय', 200], ['तिसय', 300], ['नवसय', 900],
    ['सहस्स', 1000], ['लक्ख', 100000]
]

export const NUMBER_RULES: Record<string, string> = {
    'एग': 'एकवचन; पु./स्त्री./नपुं. अकारान्त शब्दों जैसे (एगो, एगा, एगं) — नि.६७',
    '2–18 + कइ': 'केवल बहुवचन; तीनों लिंगों में समान — नि.६८–६९ (तिण्णि: तिण्णि, तीहि, तीण्ह, तीहिन्तो, तीण्ह, तीसु)',
    '19–58': 'माला (आकारान्त स्त्री.) जैसे; तीनों लिंगों में समान — नि.७०',
    '59–99': 'जुवइ (इकारान्त स्त्री.) जैसे; तीनों लिंगों में समान — नि.७१',
    'सय, सहस्स, लक्ख': 'नपुंसक अकारान्त जैसे — नि.७२'
}

// एग declines like an अकारान्त word in all three genders (नि.६७): the rule names these forms.
export const EGA_FORMS: { form: string, gender: Gender }[] = [
    { form: 'एगो', gender: 'pu' },
    { form: 'एगा', gender: 'stri' },
    { form: 'एगं', gender: 'napum' }
]

export const ORDINALS: [stem: string, hi: string][] = [
    ['पढम', 'पहला'], ['बीअ', 'दूसरा'], ['तइअ', 'तीसरा'], ['चउत्थ', 'चौथा'], ['पंचम', 'पाँचवाँ'],
    ['छट्ठ', 'छठा'], ['सत्तम', 'सातवाँ'], ['अट्ठम', 'आठवाँ'], ['नवम', 'नौवाँ'], ['दहम', 'दसवाँ'],
    ['वीसइम', 'बीसवाँ'], ['चउवीसइम', 'चौबीसवाँ'], ['सययम', 'सौवाँ']
]

export const COMPARATIVES: [base: string, comparative: string, superlative: string, hi: string][] = [
    ['अप्प', 'कणीअस', 'कणिट्ठ', 'छोटा'], ['जेट्ठ', 'जेट्ठयर', 'जेट्ठयम', 'बड़ा'],
    ['पिअ', 'पिअअर', 'पिअअम', 'प्रिय'], ['उच्च', 'उच्चअर', 'उच्चअम', 'ऊँचा'],
    ['सेट्ठ', 'सेट्ठअर', 'सेट्ठअम', 'श्रेष्ठ'], ['बहु', 'भूयस', 'भूयिट्ठ', 'बहुत'],
    ['खुद्द', 'खुद्दअर', 'खुद्दअम', 'नीच']
]

// पाठ ७३ (भूत कृदन्त, अनियमित)
export const IRREGULAR_PAST_PARTICIPLES: [form: string, root: string, hi: string][] = [
    ['गअ', 'गम/गच्छ', 'गया हुआ'], ['कअ', 'कर', 'किया हुआ'], ['दिट्ठ', 'दक्ख/पास', 'देखा हुआ'],
    ['णाअ', 'जाण/णा', 'जाना हुआ'], ['हअ', 'हण', 'मरा हुआ'], ['नट्ठ', 'नस्स', 'नष्ट हुआ'],
    ['भीअ', 'बीह', 'डरा हुआ'], ['संतुट्ठ', 'तूस', 'सन्तुष्ट हुआ'], ['णअ', 'नम', 'झुका हुआ']
]

export const IRREGULAR_GERUNDS: [form: string, hi: string][] = [
    ['दट्ठुं', 'देखकर'], ['गच्चा', 'जाकर'], ['किच्चा', 'करके'], ['णच्चा', 'जानकर'],
    ['सोच्चा', 'सुनकर'], ['दच्चा', 'देकर'], ['चिच्चा', 'छोड़कर'], ['सुत्ता', 'सोकर']
]

/** English glosses for the irregular forms (the book gives Hindi only); awaiting review like all content. */
export const IRREGULAR_EN: Record<string, string> = {
    'गअ': 'gone',
    'कअ': 'done',
    'दिट्ठ': 'seen',
    'णाअ': 'known',
    'हअ': 'killed',
    'नट्ठ': 'destroyed',
    'भीअ': 'frightened',
    'संतुट्ठ': 'satisfied',
    'णअ': 'bowed',
    'दट्ठुं': 'having seen',
    'गच्चा': 'having gone',
    'किच्चा': 'having done',
    'णच्चा': 'having known',
    'सोच्चा': 'having heard',
    'दच्चा': 'having given',
    'चिच्चा': 'having left',
    'सुत्ता': 'having slept'
}
